import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { menuStore } from 'src/fetch/menu/store';
import { linkMenu } from 'src/utils/menuSet';
import './style.scss';

interface Props {}

const MainMenu: FC<Props> = () => {
  const navigate = useNavigate();
  const menuData = menuStore((state: any) => state.result);
  const setMenu = menuStore((state: any) => state.bind);
  const dep1Menu: any[] = menuData?.data?.filter((item: any) => item.level === 1) || [];

  const handleMenuClick = (item: any) => {
    linkMenu({ selItem: item, menuData: menuData.data, setMenu, navigate });
  };

  return (
    <div className="_main_menu_layout">
      <div className="_main_div">
        <div className="_menu_box">
          {dep1Menu.map((item: any) => (
            <div
              key={item.id}
              className={['_menu', item.active ? '_active' : ''].join(' ')}
              onClick={() => handleMenuClick(item)}
            >
              <span className="_menu_text">{item.title}</span>
              <span className="_menu_underline" />
            </div>
          ))}
        </div>
        <div className="_link_box" />
      </div>
    </div>
  );
};

export default MainMenu;
